const testsTypes = {

  get: {
    request: "GET_TEST_REQUEST",
    success: "GET_TEST_SUCCESS",
    failure: "GET_TEST_FAILURE"
  },

  index: {
    request: "TESTS_INDEX_REQUEST",
    success: "TESTS_INDEX_SUCCESS",
    failure: "TESTS_INDEX_FAILURE"
  },

  xlsx: {
    request: "TESTS_XLSX_REQUEST",
    success: "TESTS_XLSX_SUCCESS",
    failure: "TESTS_XLSX_FAILURE"
  },

  pdf: {
    success: "TEST_PDF_SUCCESS",
  },

  set_errors: "SET_TEST_ERRORS",

  reset_test: "RESET_TEST",

  clear_test: "CLEAR_TEST",

}

export default testsTypes



// WEBPACK FOOTER //
// ./src/js/constants/testsTypes.js